"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultReviewSummarySetting = void 0;
var DefaultReviewSummarySetting;
(function (DefaultReviewSummarySetting) {
    DefaultReviewSummarySetting["DISABLED"] = "DISABLED";
    DefaultReviewSummarySetting["ENABLED"] = "ENABLED";
})(DefaultReviewSummarySetting || (exports.DefaultReviewSummarySetting = DefaultReviewSummarySetting = {}));
